import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Button, Box, Grid, Typography, CircularProgress, IconButton, FormControlLabel, Checkbox, Card, CardContent } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import LineaNegocio from '../../components/admin/LineaNegocio';
import apiInstance from '../../services/ServiceApi';
import ToastMessagge from '../../components/utilities/ToastMessage';

const CargaBase = () => {
 
    const [files, setFiles] = useState([]);  
    const [fileInfo, setFileInfo] = useState(''); 
    const [severity, setSeverity] = useState('success');
    const [loading, setLoading] = useState(false);   
    const [adicional, setAdicional] = useState(false); 
    const [hasTemplate, setHasTemplate] = useState(false); 
    const [lineaNegocio, setLineaNegocio] = useState(null); 
    const [openToast, setOpenToast] = useState(false);
    const [mensajeToast, setMensajeToast] = useState({})
    const hasFiles = files.length > 0;

    const clearFiles = () => {
        setFiles([]);
        setFileInfo('');
    };

    const onDrop = useCallback((acceptedFiles) => {
        setFiles(acceptedFiles); 
        let info = '';
        acceptedFiles.forEach((file) => {
            info += `Nombre: ${file.name}, Tamaño: ${file.size}, Tipo: ${file.type}\n`;
        });
        setFileInfo(info);
    }, []);

    const onUpload = () => {
    
        setLoading(true);
        files.forEach((file) => {
        const formData = new FormData();

        formData.append('cliente',file);
        formData.append('id_linea_negocio',lineaNegocio.id);
        formData.append('adicional',adicional);
        formData.append('exec_sp',true);
        apiInstance
            .post('AutloadSeparadoAPI/', formData)
            .then((response) => {
                setLoading(false);
                setOpenToast(true);
                setMensajeToast(response);
                setSeverity('success');
            })
            .catch((error) => {
                setLoading(false);
                setOpenToast(true);
                setMensajeToast(error);
                setSeverity('error');
            });
            });
        };
    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop});
    const handleLinea = (linea)=>{
        setLineaNegocio(linea)
        if (linea.plantilla_url){
            setHasTemplate(true)
            } 
    }
    return (
        <Grid container spacing={3} justifyContent="center" alignItems="center">
            <Grid item xs={12}>
                <Typography variant="h5" align="center" gutterBottom>
                    Subir Asignación
                </Typography>
            </Grid>
            <Grid item xs={12} md={10}>
                <Card>
                    <CardContent>
                        <ToastMessagge open={openToast} msg={mensajeToast} severity={severity} onClose={() => setOpenToast(false)} />

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <LineaNegocio onLineaChange={handleLinea} fullWidth variant="outlined" />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={adicional}
                                            onChange={(event) => setAdicional(event.target.checked)}
                                            color="primary"
                                        />
                                    }
                                    label="Adicional"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Box {...getRootProps()} sx={{
                                    height: 200,
                                    borderWidth: 2,
                                    borderColor: hasFiles ? 'primary.main' : 'grey.500',
                                    borderStyle: 'dashed',
                                    borderRadius: 2, p: 3,
                                    display: 'flex', flexDirection: 'column',
                                    justifyContent: 'center', alignItems: 'center',
                                    transition: 'border .3s ease-in-out'
                                }}>
                                    <input {...getInputProps()} />
                                    {hasFiles ? (
                                        <>
                                            <CloudUploadIcon color="primary" style={{ fontSize: 40 }} />
                                            <Typography variant="body2" color="textSecondary">{fileInfo}</Typography>
                                        </>
                                    ) : (
                                        <>
                                            <CloudUploadIcon color="disabled" style={{ fontSize: 40 }} />
                                            {isDragActive ? 
                                                <p>Suelta los archivos aquí...</p> : 
                                                <p>Arrastra y suelta archivos aquí, o haz clic para seleccionar archivos</p>}
                                        </>
                                    )}
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box display="flex" justifyContent="center" gap={2}>
                                    {hasFiles && (
                                        <IconButton onClick={clearFiles} color="error">
                                            <DeleteIcon />
                                        </IconButton>
                                    )}
                                    <Button 
                                        variant="contained"  color="primary"  onClick={onUpload}  disabled={loading || !hasFiles} startIcon={loading ? 
                                        <CircularProgress size={24} /> : <CloudUploadIcon />} >
                                            Cargar Archivo
                                    </Button>
                                    {hasTemplate &&
                                        <Button variant="outlined" color="primary" href={lineaNegocio.planilla_url} target="_blank" startIcon={<DownloadIcon />}>
                                            Descargar Plantilla
                                        </Button>
                                    }
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};

export default CargaBase;